
export const CAMPAIGN_LIST_ACTION = "CAMPAIGN_LIST_ACTION";
export const CAMPAIGN_LIST_SUCCESS = "CAMPAIGN_LIST_SUCCESS";
export const CAMPAIGN_LIST_FAIL = "CAMPAIGN_LIST_FAIL";

export const CAMPAIGN_DETAIL_ACTION = "CAMPAIGN_DETAIL_ACTION";
export const CAMPAIGN_DETAIL_SUCCESS = "CAMPAIGN_DETAIL_SUCCESS";

export const CAMPAIGN_CREATE_ACTION = "CAMPAIGN_CREATE_ACTION";
export const CAMPAIGN_UPDATE_ACTION = "CAMPAIGN_UPDATE_ACTION";
export const CAMPAIGN_UPDATE_SUCCESS = "CAMPAIGN_UPDATE_SUCCESS";
export const CAMPAIGN_DELETE_ACTION = "CAMPAIGN_DELETE_ACTION";
export const CAMPAIGN_CLONE_ACTION = "CAMPAIGN_CLONE_ACTION";

export const CAMPAIGN_LIST_COUNTRIES_ACTION = "CAMPAIGN_LIST_COUNTRIES_ACTION";
export const CAMPAIGN_LIST_COUNTRIES_SUCCESS = "CAMPAIGN_LIST_COUNTRIES_SUCCESS";
export const CAMPAIGN_LIST_COUNTRIES_FAIL = "CAMPAIGN_LIST_COUNTRIES_FAIL";

export const CAMPAIGN_LIST_CHANNEL_ACTION = "CAMPAIGN_LIST_CHANNEL_ACTION";
export const CAMPAIGN_LIST_CHANNEL_SUCCESS = "CAMPAIGN_LIST_CHANNEL_SUCCESS";
export const CAMPAIGN_LIST_CHANNEL_FAIL = "CAMPAIGN_LIST_CHANNEL_FAIL";

export const CAMPAIGN_FAIL = "CAMPAIGN_FAIL";

export const CAMPAIGN_CREATE_TRANSLATE_ACTION = "CAMPAIGN_CREATE_TRANSLATE_ACTION";
export const CAMPAIGN_CREATE_TRANSLATE_SUCCESS = "CAMPAIGN_CREATE_TRANSLATE_SUCCESS";

export const CAMPAIGN_UPDATE_TRANSLATE_ACTION = "CAMPAIGN_UPDATE_TRANSLATE_ACTION";
export const CAMPAIGN_UPDATE_TRANSLATE_SUCCESS = "CAMPAIGN_UPDATE_TRANSLATE_SUCCESS";

export const CAMPAIGN_DELETE_TRANSLATE_ACTION = "CAMPAIGN_DELETE_TRANSLATE_ACTION";
export const CAMPAIGN_DELETE_TRANSLATE_SUCCESS = "CAMPAIGN_DELETE_TRANSLATE_SUCCESS";

export const CAMPAIGN_PARSE_EXCEL_ACTION = "CAMPAIGN_PARSE_EXCEL_ACTION";
export const CAMPAIGN_PARSE_EXCEL_SUCCESS = "CAMPAIGN_PARSE_EXCEL_SUCCESS";
export const CAMPAIGN_PARSE_EXCEL_FAIL = "CAMPAIGN_PARSE_EXCEL_FAIL";
export const CAMPAIGN_PARSE_EXCEL_CLEAR_DATA = "CAMPAIGN_PARSE_EXCEL_CLEAR_DATA";

export const GET_MARKUP_PROMOTION_CONFIG_ACTION = "GET_MARKUP_PROMOTION_CONFIG_ACTION";
export const GET_MARKUP_PROMOTION_CONFIG_SUCCESS = "GET_MARKUP_PROMOTION_CONFIG_SUCCESS";
export const GET_MARKUP_PROMOTION_CONFIG_FAIL = "GET_MARKUP_PROMOTION_CONFIG_FAIL";

export const GET_MARKUP_PROMOTION_FLY_ACTION = "GET_MARKUP_PROMOTION_FLY_ACTION";
export const GET_MARKUP_PROMOTION_FLY_SUCCESS = "GET_MARKUP_PROMOTION_FLY_SUCCESS";
export const GET_MARKUP_PROMOTION_FLY_FAIL = "GET_MARKUP_PROMOTION_FLY_FAIL";

export const GET_MARKUP_BUNDLE_MIN_VALUE_ACTION = "GET_MARKUP_BUNDLE_MIN_VALUE_ACTION";
export const GET_MARKUP_BUNDLE_MIN_VALUE_SUCCESS = "GET_MARKUP_BUNDLE_MIN_VALUE_SUCCESS";
export const GET_MARKUP_BUNDLE_MIN_VALUE_FAIL = "GET_MARKUP_BUNDLE_MIN_VALUE_FAIL";

export const CAMPAIGN_LIST_PROMOTION_BANK_ACTION = "CAMPAIGN_LIST_PROMOTION_BANK_ACTION";
export const CAMPAIGN_LIST_PROMOTION_BANK_SUCCESS = "CAMPAIGN_LIST_PROMOTION_BANK_SUCCESS";
export const CAMPAIGN_LIST_PROMOTION_BANK_FAIL = "CAMPAIGN_LIST_PROMOTION_BANK_FAIL";
